// extracted by mini-css-extract-plugin
module.exports = {"renderer":"HeaderRenderer_renderer__dpgga"};